import { render, staticRenderFns } from "./styles.vue?vue&type=template&id=07d70101"
import script from "./styles.vue?vue&type=script&lang=js"
export * from "./styles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d70101')) {
      api.createRecord('07d70101', component.options)
    } else {
      api.reload('07d70101', component.options)
    }
    module.hot.accept("./styles.vue?vue&type=template&id=07d70101", function () {
      api.rerender('07d70101', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/brand/styles.vue"
export default component.exports